<script>
export default {
  props: ['countSelectValue', 'beginTs', 'time'],
  data () {
    return {
      rfOption: {
        legend: {
          data: ['Ua', 'Ub', 'Uc'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          y2: 40
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          name: '周波数',
          data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: [{
          name: 'Ua',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: []
        }, {
          name: 'Ub',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: []
        }, {
          name: 'Uc',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: []
        }
        ]
      },
      rfChart: {},
      // 电气量下拉框
      // countSelectValue: 1,
      transientWareData: {},

      interval: null
    }
  },
  computed: {
  },
  watch: {
    beginTs () {
      if (this.$store.state.reqMode === 'uart') {
        this.updateData()
      }
    }
  },
  async mounted () {
    this.rfChart = this.$echarts.init(document.getElementById('rfOptions'))
    // await this.updateData()
    // await this.setChartOption()

    if (this.$store.state.reqMode === 'udp') {
      if (!this.interval) {
        this.interval = setInterval(() => {
          this.updateData()
        }, 300)
      }
    }
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  },
  methods: {
    async updateData () {
      console.log('bbbb')
      let params = {
        'collection': 'meter_transient_data',
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'tsBegin': this.beginTs,
        'tsEnd': this.beginTs,
        'time': this.time,
        'fields': ['rmsa', 'rmsb', 'rmsc'],
        'transpose': false
      }
      const {data: {data}} = await this.$api.queryTsData(params)
      this.transientWareData = data[0]
      console.log('aaa', this.transientWareData)
      await this.setChartOption()
    },

    async setChartOption () {
      var max = 0
      var min = 0x7fffffff

      for (let i = 0; i < this.transientWareData.rmsa.length; i++) {
        if (max < this.transientWareData.rmsa[i]) max = this.transientWareData.rmsa[i]
        if (max < this.transientWareData.rmsb[i]) max = this.transientWareData.rmsb[i]
        if (max < this.transientWareData.rmsc[i]) max = this.transientWareData.rmsc[i]
        if (min > this.transientWareData.rmsa[i]) min = this.transientWareData.rmsa[i]
        if (min > this.transientWareData.rmsb[i]) min = this.transientWareData.rmsb[i]
        if (min > this.transientWareData.rmsc[i]) min = this.transientWareData.rmsc[i]
      }

      if (max > 1000 || min < -1000) {
        for (let i = 0; i < this.transientWareData.rmsa.length; i++) {
          this.rfOption.series[0].data[i] = this.transientWareData.rmsa[i] * 0.001
          this.rfOption.series[1].data[i] = this.transientWareData.rmsb[i] * 0.001
          this.rfOption.series[2].data[i] = this.transientWareData.rmsc[i] * 0.001
        }
        this.rfOption.yAxis[0].name = 'kV'
      } else {
        this.rfOption.series[0].data = this.transientWareData.rmsa
        this.rfOption.series[1].data = this.transientWareData.rmsb
        this.rfOption.series[2].data = this.transientWareData.rmsc

        this.rfOption.yAxis[0].name = 'V'
      }

      this.rfChart.setOption(this.rfOption)
    }
  }
}
</script>

<template>
  <div class="pg">
    <div class="dataItems">
      <div class="title">暂升暂降半波RMS值趋势图(序号{{countSelectValue + 1}})</div>
      <div style="height: calc(100% - 50px);">
        <div id="rfOptions" style="height: 100%; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/transient.css";
.pg{
  width: 100%;
}

.dataName {
  width: 15%;
}

.dataValue {
  width: 8%;
//border-right: 1px solid black;
}

.dataNvItem {
  height: calc((100% - 70px) / 11);
}
</style>



// WEBPACK FOOTER //
// src/pages/Transient/RfChart/RfChart.vue